import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
} from './base-authenticated.service';
import { AssistanceAvailabilityInterface } from '@app/interface/assistance-availability';

@Injectable({
  providedIn: 'root',
})
export class AssistanceAvailabilityApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient,
  ) {
    super(auth, httpClient);
  }

  /**
   * L'endpoint non è organization-scoped: gli orari sono gli stessi per tutti
   * i clienti. La risposta è un singolo oggetto, non una lista paginata,
   * quindi usa get() e non getRecursivePage().
   */
  public getAvailability(
    params: httpQueryParams = {},
  ): Observable<AssistanceAvailabilityInterface> {
    return this.get<AssistanceAvailabilityInterface>(
      'api/assistance-availability/',
      params,
    );
  }
}
